import axios from 'axios'
import qs from 'qs'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/api/util'
import router from "@/router";

// create an axios instance
const service = axios.create({
    baseURL: 'https://api.bitzo.cn/coupon', // url = base url + request url
    // baseURL: 'http://192.168.0.40:8899', // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        if (config.method === 'post') {
            config.data.api_token = getToken()
            config.data = qs.stringify(config.data)
        } else {
            config.params.api_token = getToken()
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data

        // if the custom code is not 20000, it is judged as an error.
        if (res.state !== 0) {
            Message({
                message: res.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            if (res.state === -1) {
                console.log(window.location.hash)
                if (window.location.path != '#/login') {
                    router.push('/login').then(r => {})
                }
            }
            return null;
        } else {
            return res.data
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
